import { gql } from '@apollo/client';

export const GET_ROOMS_PAGINATION = gql`
  query GetRoomsPagination($filter: RoomFilter!, $page: Int!, $perPage: Int!) {
    schedule {
      roomPagination(filter: $filter, page: $page, perPage: $perPage) {
        pageInfo {
          totalItems
          page
          perPage
          totalPages
          hasNextPage
          hasPreviousPage
        }
        items {
          id
          name
          organization {
            id
            name
            location {
              id
            }
          }
          reservationModes {
            parallelSlotsNumber
            reservationMode {
              id
              name
              duration
            }
          }
        }
      }
    }
  }
`;
